import type { Expense } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '#/modules/expense/utils/fields';

const fields: FormItem<Expense>[] = [
  {
    cssClass: 'tmm-section',
    caption: 'Expense Details',
    colCount: {
      xs: 1,
      sm: 1,
      md: 6,
      lg: 6,
    },
    items: [
      { ...allFields.title, colSpan: 3 },
      { ...allFields.amount, colSpan: 3 },
      { ...allFields.workOrder, colSpan: 2 },
      { ...allFields.type, colSpan: 2 },
      { ...allFields.status, colSpan: 2 },
      {
        ...allFields.description,
        colSpan: 6,
      },
    ] as FormItem<Expense>[],
  },
];

export default fields;
